import React from "react";
import {INLINE_STYLE} from "draftail";

export default function InlinePopoverOptions(props) {

    const option = (icon, label, value) => {
        const classes = Classes("option", "with-icon", {selected: props.menuParams.currentStyles.has(value)});

        return (
            <div className={classes} onClick={()=>{props.hidePopover(); props.menuParams.toggleInlineStyle(value)}}>
                <div className={Classes("ico", icon)}/>
                <div className="label">{label}</div>
            </div>
        )
    }

    return (
        <div className="ui5-popover-menu" style={{minWidth:180}}>
            {option('editor-i5-code',      'Inline code',      INLINE_STYLE.CODE)}
            {option('editor-i5-strikethrough',    'Strikethrough',    INLINE_STYLE.STRIKETHROUGH)}
            {option('editor-i5-subscript',        'Subscript',        INLINE_STYLE.SUBSCRIPT)}
            {option('editor-i5-superscript',      'Superscript',      INLINE_STYLE.SUPERSCRIPT)}
        </div>
    );
}